import { render, staticRenderFns } from "./products-tabs.vue?vue&type=template&id=9e803e28&"
import script from "./products-tabs.vue?vue&type=script&lang=js&"
export * from "./products-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports